import { createContext, ReactNode, useState } from 'react';

interface AsideStateContextType {
    isAsideOpen: boolean;
    setIsAsideOpen: (value: boolean) => void;
}

export const AsideStateContext = createContext<AsideStateContextType>({} as AsideStateContextType);

export const AsideStateContextProvider = ({
    children,
    initialImageOpen,
}: {
    children: ReactNode;
    initialImageOpen: boolean;
}) => {
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(initialImageOpen);
    return (
        <AsideStateContext.Provider value={{ isAsideOpen, setIsAsideOpen }}>
            {children}
        </AsideStateContext.Provider>
    );
};
